import axios from 'axios';

export const configFor = token => ({
  headers: { Authorization: `Bearer ${token}` },
});

export default class APIClient {
  static get = (url, token, config) =>
    axios
      .get(url, {
        ...configFor(token),
        ...config,
      })
      .then(response => response)
      .catch(e => {
        throw e;
      });

  static post = (url, params, token) =>
    axios
      .post(url, params, configFor(token))
      .then(response => response)
      .catch(e => {
        throw e;
      });

  static patch = (url, params, token) =>
    axios
      .patch(url, params, configFor(token))
      .then(response => response)
      .catch(e => {
        throw e;
      });
}
